import 'jquery';

export default class UnreadIndicator {
	private _intervals: any = {};
	private _project: number;

	constructor(project: number = null) {
		this._project = project;
	}

	startTracking(tab: string, callback: () => void): void {
		let self = this;
		let interval = window.setInterval(function () {
			self.resetInterval(tab);

			$.post(
				'/track/' + tab + window.location.search, // for impersonation, e.g. ?person=1
				{
					project: self._project
				},
				function () {
					if (callback)
						callback();
				}
			);
		}, 2000);

		this._intervals[tab] = interval;
	}

	stopTracking(tab: string) {
		this.resetInterval(tab);
	}

	private resetInterval(tab: string) {
		window.clearInterval(this._intervals[tab]);
		this._intervals[tab] = null;
		delete this._intervals[tab];
	}
}